(($) => {

    'use strict'

    $('.wpgpxmaps').find('canvas').appendTo('#altitude-chart')
    $('#difficulty-icon').appendTo('#global-header h1')

    window.onload =  () => {

		window.dispatchEvent(new Event('resize'))

		$('input[name="recipient"]').val($('#form-data').data('recipient'))
		$('input[name="hiking"]').val($('#form-data').data('hiking'))

		$('.gfield_html').each(function() {

			$(this)
				.find('img')
				.addClass('img-shop')
				.prependTo($(this).next());

			$(this)
				.hide();

		})
		
	}

    InstantClick.on('change', () => {
		window.dispatchEvent(new Event('resize'))
	})

})(jQuery)
